const readEnvStr = (key: string, defaultValue?: string): string =>
  process.env[key] ?? defaultValue ?? '';

export const ENVIRONMENT = {
  stage: readEnvStr('REACT_APP_PROJECT_ID')?.split('-')[0] ?? 'prod',
  releaseVersion: readEnvStr('REACT_APP_RELEASE_VERSION', 'v1.0.0'),
  publicGateway: {
    baseUrl: readEnvStr('REACT_APP_PUBLIC_GATEWAY_BASE_URL'),
    tenant: readEnvStr('REACT_APP_PUBLIC_GATEWAY_TENANT', 'exeter-uk'),
    applicationId: readEnvStr(
      'REACT_APP_PUBLIC_GATEWAY_APPLICATION_ID',
      '0194b942-c3f6-484f-8d91-762f9755921f'
    ),
  },
  cognito: {
    userPoolId: readEnvStr('REACT_APP_COGNITO_USER_POOL_ID'),
    resourceManagerGroupId: readEnvStr('REACT_APP_COGNITO_RESOURCE_MANAGER_GROUP_ID'),
    clientId: readEnvStr('REACT_APP_COGNITO_CLIENT_ID'),
    domain: readEnvStr('REACT_APP_COGNITO_DOMAIN'),
    redirectSignIn: readEnvStr('REACT_APP_COGNITO_REDIRECT_SIGN_IN'),
    redirectSignOut: readEnvStr('REACT_APP_COGNITO_REDIRECT_SIGN_OUT'),
  },
  firebase: {
    apiKey: readEnvStr('REACT_APP_API_KEY'),
    authDomain: readEnvStr('REACT_APP_AUTH_DOMAIN'),
    projectId: readEnvStr('REACT_APP_PROJECT_ID'),
    storageBucket: readEnvStr('REACT_APP_STORAGE_BUCKET'),
    messagingSenderId: readEnvStr('REACT_APP_MESSAGING_SENDER_ID'),
    appId: readEnvStr('REACT_APP_APP_ID'),
    measurementId: readEnvStr('REACT_APP_MEASUREMENT_ID'),
  },
} as const;
